import {
  CustomDetector,
  DetectorOptions
} from 'i18next-browser-languagedetector';
import { QueryParser, SimpleQueryParser } from './SimpleQueryParser';

export interface FragmentDetectorOptions extends DetectorOptions {
  languageFragmentString: string;
}

export class FragmentLanguageDetector implements CustomDetector {
  name = 'fragment';

  private parser: QueryParser;

  constructor() {
    const search = (): string | undefined => {
      if (!window || !window.location || !window.location.hash) {
        return undefined;
      }
      return window.location.hash;
    };

    this.parser = new SimpleQueryParser(search);
  }

  public lookup(options: FragmentDetectorOptions): string | undefined {
    const searchOptions: FragmentDetectorOptions = {
      ...this.getDefaults(),
      ...options
    };

    const culture = this.parser.getQueryParam(
      searchOptions.languageFragmentString
    );

    return culture;
  }

  private getDefaults = (): FragmentDetectorOptions => {
    return {
      languageFragmentString: 'culture'
    };
  };
}
